import type { Entry, ILinkItem } from '@belong/types';

export const isEntryLinkListItem = (entry: Entry<any>): boolean =>
  entry.sys.contentType.sys.id === 'moleculeLinkListItem';

export const FLinkListItem = (data: any): ILinkItem => {
  const { shouldOpenInNewTab, url, ...fields } = data.fields;

  if (data.fields.shouldOpenInNewTab) {
    fields.target = '_blank';
  }

  return {
    ...fields,
    href: url.fields.url
  };
};
